module.exports = __webpack_public_path__ + "img/Sala de Bar.8ae13330.png";